import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Box, Flex } from '@chakra-ui/react';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import WarningTextMessage from '../../global/components/helper-components/components/WarningTextMessage';
import { reloadPage, validateEmail } from '../../global/helpers/global-helpers';
import PageLoader from '../../global/components/helper-components/components/PageLoader';
import LaunchdeckFormInput from '../../forms/TextInputField/components/LaunchdeckFormInput';

function DsrReturningLoginForm({ 
	defaultEmail, 
	handleSubmitLoginRequest, 
	// Redux
	loginOutcome, 
	isProcessingLogin 
} ) {

	// Inputs
	const [passwordInput, setPasswordInput] = useState('');

	const [showInputError, setShowInputError] = useState(false);
	const [showValidationError, setShowValidationError] = useState(false);
	const [showLoginError, setShowLoginError] = useState(false);
	const [errorMessage, setErrorMessage] = useState("")


	useEffect(() => {
		if (loginOutcome) {
			const { isLoginError, errorPayload } = loginOutcome || {}
			if (isLoginError) {
				setShowLoginError(true)
				setErrorMessage(errorPayload.errorMessage)
				setPasswordInput("")
			}
		}
	}, [loginOutcome])

	function onPressEnterAndLogin(e) {
		if (e.key === 'Enter') {
			handleSubmit();
		}
	}

	const onChangeHandler = (event) => {

		switch (event.target.name) {
			case ('password-input'): {
				if (showInputError) {
					setShowInputError(false)
				}

				if (showLoginError) {
					setShowLoginError(false)
				}

				setPasswordInput(event.target.value.trim())
				break;
			}
			default: {
				break;
			}
		}
	};

	const handleSubmit = () => {
		const trimmedEmail = defaultEmail.trim();
		const isValidEmail = validateEmail(trimmedEmail);
		const isValidPassword = (passwordInput?.length >= 6) ? true : false

		if (!isValidEmail) {
			setShowValidationError(true)
		} else if (!isValidPassword) {
			setShowInputError(true)
		} else if (isValidEmail && isValidPassword) {
			handleSubmitLoginRequest(trimmedEmail, passwordInput);
		}
	}

	return (
		<Box w="100%" align="center" maxW='25em'>
				{isProcessingLogin ? <PageLoader /> :
			<Flex direction='column' align='center' w='100%' maxW='30em' px='1em' mt='1em'>
					<Flex direction='column' align='center' w='100%' gap='1.25em' onKeyDown={(e) => onPressEnterAndLogin(e)}>
						<LaunchdeckFormInput
							label='Email'
							// name={'email'}
							// onChange={onChangeHandler}
							value={defaultEmail}
							placeholder={'me@email.com'}
							isDisabled={true}

							errorLogic={showValidationError}
							errorMessage={`Please use the 'Back' button & provide a valid email`}
						/>

						<LaunchdeckFormInput
							label='Password'
							name={'password-input'}
							onChange={onChangeHandler}
							value={passwordInput}
							type='password'

							errorLogic={showInputError}
							errorMessage={`Please set a secure password that contains more than 8 characters`}
						/>
					</Flex>

					<Flex w='100%' justify='center' my='1em'>
				<WarningTextMessage errorLogic={showLoginError && !showInputError} message={`${errorMessage}`} />
			</Flex>

			<Flex direction='column' align='center' w='100%' mt='1.5em' gap='0.5em'>
				<Flex justify='flex-end' w='100%'>
					<LaunchdeckButton bg={isProcessingLogin ? 'gray.300' : 'brand.500'} color={isProcessingLogin ? 'gray.500' : 'gray.50'} w='100%' label='Enter Room' dummy={isProcessingLogin} onClick={() => !isProcessingLogin && handleSubmit()} />
				</Flex>
				<Flex mt='0.5em' w='100%' gap='0.5em' justify='center' color='gray.500' fontSize={['0.5em', '0.7em']}>
					<Box cursor='pointer' onClick={() => !isProcessingLogin && reloadPage()} >Back</Box>
					<Box>•</Box>
					<Link to="/reset-password">Forgot Password?</Link>
				</Flex>
			</Flex>
			</Flex>
			}

		
		</Box>
	)
}


function mapStateToProps(state) {
	return {
		loginOutcome: state.auth.data.login.results?.data,
		isProcessingLogin: state.auth.data.login.loading,
	};
}


export default withRouter(connect(mapStateToProps, null)(DsrReturningLoginForm));